import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AlertRule } from '../types/Alerts'
import { AlertRuleName } from '../enums'
import { AlertRuleDataGridRow } from '../types/AlertRuleDataGridRow'

export type AlertRuleFunction =
  | 'avg_over_time'
  | 'max_over_time'
  | 'min_over_time'
  | 'stddev_over_time'
  | 'stdvar_over_time'

export interface AlertRuleFunctionSelectProps extends Omit<
  SelectProps<AlertRuleFunction>,
  'children' | 'onChange'
> {
  rule?: AlertRule | AlertRuleDataGridRow
  onChange?: (event: SelectChangeEvent, value: AlertRuleFunction) => void
}

export default function AlertRuleFunctionSelect({
  rule,
  value,
  onChange,
  fullWidth = true,
  ...props
}: AlertRuleFunctionSelectProps) {
  const { t } = useTranslation('alert')

  function handleChange(event: SelectChangeEvent) {
    onChange?.(event, event.target.value as AlertRuleFunction)
  }

  function getOptions() {
    switch (rule?.name) {
      case AlertRuleName.SHORT_CIRCUIT:
        return ['avg_over_time', 'min_over_time', 'max_over_time']
      default:
        return [
          'avg_over_time',
          'max_over_time',
          'min_over_time',
          'stddev_over_time',
          'stdvar_over_time'
        ]
    }
  }

  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel id="alert-rule-function-select-label">{t('function')}</InputLabel>
      <Select
        labelId="alert-rule-function-select-label"
        label={t('function')}
        value={value ?? ''}
        onChange={handleChange}
        fullWidth={fullWidth}
        {...props}
      >
        <MenuItem value="avg_over_time">{t('AlertRuleFunction.avg_over_time')}</MenuItem>
        <MenuItem value="max_over_time">{t('AlertRuleFunction.max_over_time')}</MenuItem>
        <MenuItem value="min_over_time">{t('AlertRuleFunction.min_over_time')}</MenuItem>
        <MenuItem value="stddev_over_time">{t('AlertRuleFunction.stddev_over_time')}</MenuItem>
        <MenuItem value="stdvar_over_time">{t('AlertRuleFunction.stdvar_over_time')}</MenuItem>
      </Select>
    </FormControl>
  )
}
